module.exports = require("./pt-PT.d.ts");